import React, { Fragment, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Popover from '@material-ui/core/Popover';
import EventNoteIcon from '@material-ui/icons/EventNote';
import { Calendar } from 'react-datepicker2';
import moment from 'moment-jalaali';

const DatePicker = ({
  label = 'تاریخ',
  variant = 'outlined',
  size = 'small',
  value = '',
  onChange = null,
  disabled = false,
  format = 'jYYYY/jMM/jDD',
  min,
  max,
  ...rest
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleChange = (date) => {
    onChange(date);
    handleClose();
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <TextField
        fullWidth
        label={label || ''}
        value={value ? moment(value).format(format) : ''}
        variant={variant}
        size={size}
        placeholder="انتخاب تاریخ"
        onChange={null}
        onClick={handleClick}
        disabled={disabled}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <EventNoteIcon style={{ color: 'aba9a9' }} />
            </InputAdornment>
          ),
        }}
        {...rest}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Calendar
          defaultMonth={!value ? moment() : moment(value)}
          min={min}
          max={max}
          value={!value ? moment() : moment(value)}
          isGregorian={false}
          onChange={handleChange}
        />
      </Popover>
    </Fragment>
  );
};

export default React.memo(DatePicker);
